function b(I, g) {
  return g.reduce((o, m) => {
    const {
      ingredients: c,
      addonId: F,
      selectedIngredientId: l,
      selectedCount: a
    } = m, f = I.find((e) => e.addOnGroupId === F);
    if (f) {
      const { ingredients: e, addOnSettings: A } = f;
      if (l) {
        const n = e == null ? void 0 : e.find(
          (t) => t.id === l
        );
        if (n) {
          const t = c.some(
            (i) => i.freeAmount === 1
          ), { price: s } = n;
          return o + (t ? 0 : s);
        }
      }
      const { afterFreePrice: p, freeAmount: d } = A, O = d !== null && p !== null && d > 0 && a > d, D = c.reduce(
        (n, t) => {
          const {
            selectedCount: s,
            freeAmount: i
          } = t;
          if (a > 0) {
            const u = s - i;
            if (u === 0)
              return n;
            if (O) {
              const r = u * p.amount;
              return n + r;
            }
            const C = e == null ? void 0 : e.find(
              (r) => r.id === t.id
            );
            if (C) {
              const { price: r } = C, G = r * u;
              return n + G;
            }
          }
          return n;
        },
        0
      );
      return o + D;
    }
    return o;
  }, 0);
}
export {
  b as default
};
